import { type ICreateClientWithIdBody } from "@gen/app-query";
import * as z from "zod";

const createClientWithIdSchema = z.object({
  id: z.string({
    error: (issue) => {
      if (issue.input === undefined) {
        return "Please enter an Client ID";
      }
    },
  }),

  name: z
    .string({
      error: (issue) => {
        if (issue.input === undefined) {
          return "Please enter a Client Name";
        }
      },
    })
    .min(1, {
      error: (issue) => {
        if (issue.code === "too_small") {
          return "Please enter a Client Name";
        }
      },
    }),

  contact_email: z.email({
    error: (issue) => {
      if (issue.input === undefined) {
        return "Please enter a Contact Email";
      }
      return "Please enter a valid Contact Email";
    },
  }),

  base_url: z.url({
    error: (issue) => {
      if (issue.input === undefined) {
        return "Please enter a Base URL";
      }
      return "Please enter a valid Base URL";
    },
  }),

  redirect_uris: z
    .array(
      z.url({
        error: (issue) => {
          if (issue.input === undefined) {
            return "Please enter a Redirect URI";
          }
          return "Please enter a valid Redirect URI";
        },
      }),
    )
    .min(1, {
      message: "Please add a Redirect URI",
    }),
}) satisfies z.ZodType<ICreateClientWithIdBody>;

export const clientRedirectUriSchema = z.object({
  id: z.string(),
  uri: z.url({
    error: (issue) => {
      if (issue.input === undefined) {
        return "Please enter a Redirect URI";
      }
      return "Please enter a valid Redirect URI";
    },
  }),
});

export const createClientFormSchema = createClientWithIdSchema.extend({
  redirect_uris: z.array(clientRedirectUriSchema).min(1, {
    message: "Please add a Redirect URI",
  }),
});
